module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('v-style', [_vm._v("div.modal-wrapper .modal-container .modalBody { width: unset; } #svgfocus { outline: none; }")]), _vm._v(" "), _c('PlanoNext', {
    attrs: {
      "assets": _vm.images,
      "locale": _vm.$t('trad'),
      "catalogPanes": _vm.catalogPanes,
      "catalogItems": _vm.catalogItems
    },
    on: {
      "search-changed": function (e) { return _vm.$emit('search-changed', e); }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d16fe35e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/plano-engine.vue
// module id = 3373
// module chunks = 0